import {texture} from "p3";
import definitions from "../../../definitions";
import NPC from "./NPC";

export default class NPCPrinceSvan extends NPC {
    constructor() {
        super(definitions.NPC_ID.PRINCE_SVAN);

        this.collisionRadius = 26;
        this.collisionOffsetX = -20;
        this.collisionOffsetY = -26;
    }

    init() {
        super.init();

        this.addViewWithTexture(texture("char_prince_svan_idle_00"));

        this.addShadow(definitions.SHADOW_SIZE.LARGE, 0.6, new PIXI.Point(-20, -6));
        this.animateIdle(0.4);
    }
}